import { render, staticRenderFns } from "./ImportDataDialogUpload.vue?vue&type=template&id=08d10883&scoped=true"
import script from "./ImportDataDialogUpload.vue?vue&type=script&lang=js"
export * from "./ImportDataDialogUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d10883",
  null
  
)

export default component.exports